import type { PropsWithChildren } from 'react';

import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { Heading } from 'src/styles';

import { BacklinkButton } from '../../Miscellaneous/BacklinkButton/BacklinkButton';

import * as Styles from './MyAccountLayout.styles';
import { MyAccountSidebar, MyAccountSidebarMenuItemKey } from './MyAccountSidebar';

export interface MyAccountLayoutProps {
  title?: string;
  backlink?: { to: string; label: string };
  sidebarMenuItemKey: MyAccountSidebarMenuItemKey;
  testId?: string;
}

export const MyAccountLayout = ({
  title,
  children,
  sidebarMenuItemKey,
  backlink,
  testId,
}: PropsWithChildren<MyAccountLayoutProps>) => {
  return (
    <Row>
      <MyAccountSidebar menuItemKey={sidebarMenuItemKey} />
      <Col span={16} sm={24} xs={24} md={15} lg={16}>
        {backlink && (
          <div className={Styles.backlinkButtonContainer}>
            <BacklinkButton to={backlink.to} label={backlink.label} />
          </div>
        )}
        {title && (
          <div
            className={cx(Heading.title, Styles.title({ hasBacklink: Boolean(backlink) }))}
            data-testid={testId + '-title-section'}>
            {title}
          </div>
        )}
        <div className={Styles.mainContainer}>{children}</div>
      </Col>
    </Row>
  );
};
